import { Conversa, Recado } from '../interfaces/recados.dto';

const normalizar = (nome: string | null | undefined): string => (nome ?? '').trim().toUpperCase();

/** Mesma regra do Codificar do back: unidade UTF-16 acima de 0x7E vira \uXXXX (6 caracteres). */
export function tamanhoCodificado(texto: string): number {
  let total = 0;
  for (let i = 0; i < texto.length; i++) total += texto.charCodeAt(i) > 0x7e ? 6 : 1;
  return total;
}

/** nrSequencia cresce com o tempo; evita parsear dtCriacaoFmt (DD/MM/YYYY). */
const maisRecenteAntes = (a: Recado, b: Recado) => b.nrSequencia - a.nrSequencia;

export function agruparConversas(recados: Recado[], eu: string): Conversa[] {
  const meu = normalizar(eu);
  const grupos = new Map<string, Recado[]>();
  for (const r of recados) {
    const outro = normalizar(r.nmRemetente) === meu ? r.nmDestinatario : r.nmRemetente;
    const chave = normalizar(outro);
    if (!chave) continue;
    const lista = grupos.get(chave) ?? [];
    lista.push(r);
    grupos.set(chave, lista);
  }
  return [...grupos.values()]
    .map(lista => {
      const ordenados = [...lista].sort(maisRecenteAntes);
      const ultima = ordenados[0];
      const outro = normalizar(ultima.nmRemetente) === meu ? ultima.nmDestinatario : ultima.nmRemetente;
      const naoLidas = ordenados.filter(r => normalizar(r.nmDestinatario) === meu && normalizar(r.nmRemetente) !== meu && r.ieLido === 'N').length;
      return { outro: (outro ?? '').trim(), recados: ordenados, naoLidas, ultima };
    })
    .sort((a, b) => maisRecenteAntes(a.ultima, b.ultima));
}

/** Os novos vencem os atuais de mesmo nrSequencia (lido/fixado mudam). */
export function mesclarRecados(atual: Recado[], novos: Recado[]): Recado[] {
  const mapa = new Map<number, Recado>();
  for (const r of atual) mapa.set(r.nrSequencia, r);
  for (const r of novos) mapa.set(r.nrSequencia, r);
  return [...mapa.values()].sort(maisRecenteAntes);
}

export function chaveLocal(tipo: 'favoritos' | 'arquivadas', login: string): string {
  return `fila:recados:${tipo}:${login}`;
}
